import { DateTime } from "luxon";
import ColumnHeader from "./ColumnHeader";
import SectionWrapper from "./SectionWrapper";
import DescriptionList from "../Shared/DescriptionList";
import StatusIndicator from "../Shared/StatusIndicator";
import { COLOUR } from "../../config/constants";

const ClientInformation = ({ client, buttons, menuItems, onClick }) => {
  const clientSince = client?.createdAt
    ? DateTime.fromISO(client.createdAt).toFormat("MMMM yyyy")
    : null;

  const emailLink = client?.email ? (
    <a href={`mailto:${client.email}`} className="text-accent-600 hover:text-accent-500 underline">
      {client.email}
    </a>
  ) : null;

  const phoneLink = client?.phoneNumber ? (
    <a href={`tel:${client.phoneNumber}`} className="text-accent-600 hover:text-accent-500 underline">
      {client.phoneNumber}
    </a>
  ) : null;

  const items = [
    { label: "Full name", value: client?.fullName },
    { label: "Email address", value: emailLink },
    { label: "Phone number", value: phoneLink },
    { label: "Address", value: client?.serviceAddress?.full },
    { label: "Notes", value: client?.note },
  ].filter((item) => item.value);

  return (
    <SectionWrapper>
      <ColumnHeader
        title={
          <div className="flex items-center gap-2">
            <span>Client Details</span>
            {client?.archived && (
              <StatusIndicator colour={COLOUR.GRAY} label="Archived" />
            )}
          </div>
        }
        subtitle={clientSince ? `Client since ${clientSince}` : null}
        onClick={onClick}
        buttonCaption={"Edit"}
        buttons={buttons}
        menuItems={menuItems}
      />
      <DescriptionList items={items} />
    </SectionWrapper>
  );
};

export default ClientInformation;
